var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"none","d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3","key":1})]);
}

Facebook.defaultProps = {"className":"icon icon-tabler icon-tabler-brand-facebook","width":"24","height":"24","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","fill":"none","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Facebook;

Facebook.default = Facebook;
